export function timeFormtChn(timestamp, showTime = true) {
  const date = new Date(timestamp * 1000)

  let month = date.getMonth() + 1;
  let day = date.getDate();
  let hour = date.getHours();
  let min = date.getMinutes();
  let sec = date.getSeconds();

  month = (month < 10 ? "0" : "") + month;
  day = (day < 10 ? "0" : "") + day;
  hour = (hour < 10 ? "0" : "") + hour;
  min = (min < 10 ? "0" : "") + min;
  sec = (sec < 10 ? "0" : "") + sec;


  if (!showTime) {
    return date.getFullYear() + '年' + month + '月' + day + '日'
  } else {
    return date.getFullYear() + '年' + month + '月' + day + '日' + ' ' + hour + ':' + min + ':' + sec
  }
  // date.getSeconds(),
}


export function timeFormt(timestamp, showTime = true) {
  const date = new Date(timestamp * 1000)

  let month = date.getMonth() + 1;
  let day = date.getDate();
  let hour = date.getHours();
  let min = date.getMinutes();
  let sec = date.getSeconds();

  month = (month < 10 ? "0" : "") + month;
  day = (day < 10 ? "0" : "") + day;
  hour = (hour < 10 ? "0" : "") + hour;
  min = (min < 10 ? "0" : "") + min;
  sec = (sec < 10 ? "0" : "") + sec;


  if (!showTime) {
    return date.getFullYear() + '-' + month + '-' + day
  } else {
    return date.getFullYear() + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + sec
  }
  // date.getSeconds(),
}

function pad0(num) {
  if (num < 10) {
    return '0' + num
  }
  return num
}

export function countDownFormt(seconds) {
  if(seconds <= 0){
    return '0天00:00:00'
  }
  const day = Math.floor(seconds / 86400);
  let remain = seconds % 86400;
  const hour = Math.floor(remain / 3600);
  remain = remain % 3600;
  const minutes = Math.floor(remain / 60);
  remain = remain % 60;
  return day + '天'  + pad0(hour) + ':' + pad0(minutes) + ':' + pad0(remain);
}


/**
 * 获取指定时间的友好时间字符串。
 * @param oldTimeStr 指定的时间字符串，如yyyy-MM-dd HH:mm:ss
 * @param nowStr 当前时间，允许时间戳，GMT时间，如果该参数为undefined，则使用浏览器时间。
 */
export function friendlyTime(oldTimeStr, nowStr) {
  try {
    let currentTime = null;
    if (nowStr) {
      currentTime = new Date(nowStr.replace(/-/g, "/"));
    } else {
      currentTime = new Date()
    }
    const oldTime = new Date(oldTimeStr.replace(/-/g, "/"));

    const delta = currentTime.getTime() - oldTime.getTime();
    console.log(currentTime.getFullYear(), oldTime.getFullYear())
    if (delta <= 6000) {
      return "刚刚";
    }
    else if (delta < 60 * 60 * 1000) { //60分钟内
      return Math.ceil(delta / (60 * 1000)) + "分钟前";
    }
    else if (delta < 24 * 60 * 60 * 1000) { //24小时内
      return Math.ceil(delta / (60 * 60 * 1000)) + "小时前";
    }
    else if (delta < 7 * 24 * 60 * 60 * 1000) { //7天内
      return Math.ceil(delta / (24 * 60 * 60 * 1000)) + "天前";
    }
    else if (currentTime.getFullYear() === oldTime.getFullYear()) {
      return (oldTime.getMonth() + 1) + "月" + oldTime.getDate() + "日"
    }
    else {
      return oldTime.getFullYear() + "年" + (oldTime.getMonth() + 1) + "月" + oldTime.getDate() + "日"
    }

    return "";
  } catch (e) {
    return ""
  }

}



// WEBPACK FOOTER //
// ./src/tools/time-format.js